<template>
  <div v-if="!(isBookieAllRatingsModal && window.size.desktop) || window.size.desktop">
    <div class="z-[900] fixed left-0 top-0 w-screen h-screen !bg-black/50" @click="closeModal"></div>
    <div class="z-backdrop fixed left-0 top-0 w-full h-full xl:top-1/3" @click="closeModal">
      <div class="bg-zt-dark border border-zt-light rounded-zt z-modal
           xl:absolute xl:left-1/2  xl:-translate-x-1/2 xl:translate-y-[39px] xl:h-[434px] xl:w-[412px]" 
      :class="[
        { 'translate-y-[32px] h-[calc(100%-32px)]': isUserWithAdminPanel && window.size.mobile },
        { 'h-full': !isUserWithAdminPanel && window.size.mobile }
      ]"
      style="box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.1), 0px 4px 4px 0px rgba(0, 0, 0, 0.09), 0px 9px 5px 0px rgba(0, 0, 0, 0.05), 0px 16px 6px 0px rgba(0, 0, 0, 0.01), 0px 25px 7px 0px rgba(0, 0, 0, 0)" 
      @click.stop>
        <div class="h-[51px] w-full flex items-center py-3.5 pl-5 pr-12 top-0 border-b border-[#313A44] relative">
          <div v-if="!isBookieAllRatingsModal && !functionalityName" class="font-semibold truncate xl:w-[330px]">
            <span v-if="ratingType">{{ ratingType }}</span>
            <span v-if="ratingType"> > </span>
            <span>{{ selectedItemName }}</span>
          </div>
          <div v-if="isBookieAllRatingsModal || functionalityName" 
               class="absolute top-0 left-1/2 -translate-x-1/2 rounded-b-xl overflow-hidden h-[48px] w-[115px]">
            <div class="-translate-y-2.5 bg-cover w-full h-[69px] rounded-b-xl" 
                 :class="{'zt-hover cursor-pointer': shouldRedirect}"
                 :style="{ backgroundImage: `url('/wp-content/themes/zawodtyper/assets/images/bukmacherzy/${bookmakerName.toLowerCase()}.svg')` }"
                 @click="redirectToPromoPage(promoUrl, shouldRedirect)"></div>
          </div>
          <div class="x-close-modal" @click.stop="closeModal()"></div>
        </div>
        <div class="flex flex-col overflow-x-hidden overflow-y-auto h-[calc(100%-51px)] pt-2.5 xl:pt-4" 
             :class="isBookieAllRatingsModal ? 'px-4' : 'px-6'">
          <div v-if="isModalDataLoading" class="w-full h-full flex flex-col justify-center items-center mt-5">
            <svg class="mr-2 w-8 h-8 animate-spin fill-zt-red" viewBox="0 0 100 101">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
            <span v-if="!isBookieAllRatingsModal && !functionalityName" class="mt-4 animate-bounce">Ładowanie bukmacherów</span>
            <span v-else class="mt-4 animate-bounce">Ładowanie funkcjonalności</span>
          </div>
          <div v-else class="flex-1 xl:w-[366px]">
            <div v-if="description && description !== ''"
                 class="relative min-h-16 flex gap-2 px-3 py-2.5 bg-zt-light/35 border border-zt-light rounded-zt mb-3 items-center">
              <p v-if="showExpandButton" class="text-xs leading-5">
                <span>{{ expanded ? description : truncatedDescription }}</span>
                <button v-if="!expanded" @click="toggleExpand" class="text-zt-more underline cursor-pointer ml-1 zt-hover">
                  ROZWIŃ
                </button>
              </p>
              <p v-else class="text-xs leading-5">
                <span v-html="description"></span>
              </p>
              <svg class="absolute top-1/2 -translate-y-1/2 opacity-60"
                   :class="description.length < 160 ? 'w-3 right-6' : 'right-8'"
                   width="20" height="72" viewBox="0 0 20 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.0472 24.1953L1.09217 26.4456L0.450918 29.4262L3.98373 30.0675C6.28154 30.6197 6.73873 31.445 6.23998 33.7428L0.450918 60.9188C-1.06314 67.9428 1.28217 71.25 6.78623 71.25C11.0612 71.25 16.0131 69.2788 18.2634 66.5653L18.9522 63.3056C17.3906 64.6831 15.0928 65.2353 13.5787 65.2353C11.4234 65.2353 10.6456 63.7212 11.1919 61.0553L19.0472 24.1953ZM19.5875 7.8375C19.5875 9.91613 18.7617 11.9096 17.2919 13.3794C15.8221 14.8493 13.8286 15.675 11.75 15.675C9.67135 15.675 7.67785 14.8493 6.20803 13.3794C4.73821 11.9096 3.91248 9.91613 3.91248 7.8375C3.91248 5.75887 4.73821 3.76537 6.20803 2.29555C7.67785 0.825734 9.67135 0 11.75 0C13.8286 0 15.8221 0.825734 17.2919 2.29555C18.7617 3.76537 19.5875 5.75887 19.5875 7.8375Z" fill="#93A3BA" fill-opacity="0.1"/>
              </svg>
            </div>
            <div v-if="isBookieAllRatingsModal && filteredSelectedRatings.length > 0">
              <span class="flex justify-center pt-0.5 pb-3 text-xs text-zt-more">WYBRANE:</span>
              <template v-for="(item, index) in filteredSelectedRatings" :key="item.id">
                <bookmaker-rating-item 
                    :item="item"
                    :index="index + 1"
                    :bookmakerName="bookmakerName"
                    :isRatingModal="true"
                    :isSelectedRating="true"
                    :show-hover="showHover"
                    :isBookieAllRatingsModal="isBookieAllRatingsModal"
                    @open-modal="openModal" />
              </template>
              <hr class="mt-5 border-b-0.5 border-zt-light" />
              <span class="flex justify-center py-3 text-xs text-zt-more">POZOSTAŁE:</span>
            </div>
            <div v-for="(item, index) in filteredRatings" :key="item.id">
              <bookmaker-rating-item 
                    :item="item"
                    :index="index + 1"
                    :bookmakerName="bookmakerName"
                    :functionalityName="functionalityName"
                    :isRatingModal="true"
                    show-icons
                    :show-hover="showHover"
                    :isBookieAllRatingsModal="isBookieAllRatingsModal"
                    @open-modal="openModal" />
            </div>
            <span v-if="showMessage" class="flex justify-center text-[11px] font-normal text-zt-more">
              Nie każdy bukmacher posiada tę funkcjonalność
            </span>
          </div>
          <div>
            <div v-if="!isModalDataLoading && (isBookieAllRatingsModal || functionalityName) && bonusData?.amount && bonusData?.amount_title"
                 class="flex flex-col items-center leading-1.5">
              <span class="text-[28px] font-bold mt-2">{{ bonusData.amount }}</span>
              <span class="text-sm font-semibold uppercase">{{ bonusData.amount_title }}</span>
              <div class="mt-5 mb-2 text-zt-more flex items-center gap-2.5"
                   :class="{ 'cursor-pointer zt-hover': shouldRedirect }"
                   @click="redirectToPromoPage(promoUrl, shouldRedirect)">
                <span>Kod promocyjny {{ bookmakerNameWithUpperCase }}</span>
                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.3437 13.6275L15.9955 7.00004L10.3437 0.372559L9.42061 1.45498L13.5178 6.24045L3.23438 6.24045L3.23438 7.75964L13.5178 7.75964L9.42061 12.5451L10.3437 13.6275Z" fill="#93A3BA"/>
                  <path d="M1.29555 6.23975H0L0 7.75894H1.29555L1.29555 6.23975Z" fill="#93A3BA"/>
                </svg>
              </div>
            </div>
            <button class="px-4 py-3 mt-3 mb-4 bg-zt-light border-zt-light rounded-zt zt-hover w-full xl:w-[366px]"
                    @click.stop="closeModal()">
              <span class="text-sm font-semibold">ZAMKNIJ OKNO</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import BookmakerRatingItem from '../BookmakerRatingItem.vue';

export default {
  name: 'BookmakerRatingModal',
  inject: ['WP'],
  mixins: [utils_mixin],
  emits: ['close-modal', 'open-modal'],
  components: {
    BookmakerRatingItem
  },
  data() {
    return {
      isUserWithAdminPanel: false,
      items: [],
      bonusData: [],
      showMessage: false,
      isModalDataLoading: true,
      isSecondOrderModal: false,
      description: '',
      expanded: false,
      maxLength: window.size.desktop ? 198 : 160,
      bookmakersCount: 14,
      secondOrderFunctionalityName: '',
      promoUrl: '',
      rankingBukmacherowPageId: 36
    };
  },
  props: {
    selectedItemName: String,
    ratingType: String,
    bookmakerName: String,
    isBookieAllRatingsModal: Boolean,
    filteredSelectedRatings: Object,
    functionalityName: String,
    showHover: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.bookmakerName) {
      this.promoUrl = utils_mixin.methods.getBookiePromoLink(this.bookmakerName);
    }
    this.isUserWithAdminPanel = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor';
    if (!this.isSecondOrderModal) {
      this.getData();
    }
    setTimeout(this.refreshTooltips, 300);
    window.addEventListener('resize', this.handleResize);
  },
  computed: {
    bookmakerNameWithUpperCase() {
      return this.bookmakerNameToUpperCase(this.bookmakerName);
    },
    truncatedDescription() {
      return this.description.slice(0, this.maxLength - this.selectedItemName.length) + '...';
    },
    showExpandButton() {
      return this.description.length > this.maxLength + 20;
    },
    filteredRatings() {
      if (this.filteredSelectedRatings) {
        const otherRatings = Object.values(this.items).filter(rating => {
          return !this.filteredSelectedRatings.some(selectedRating => selectedRating.name === rating.name);
        });
        return otherRatings;
      } else {
        return this.items;
      }
    },
    isBookmakerRankingPage() {
      if (window.location.pathname === '/ranking-bukmacherow/' || this.WP.root_category_id === 13) {
        return true;
      } else {
        return false;
      }
    },
    shouldRedirect() {
      if (this.promoUrl === window.location.pathname) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    getData() {
      if ((this.isBookieAllRatingsModal && !this.isSecondOrderModal) || this.functionalityName) {
        this.getBookmakerRatings();
      } else {
        this.getFunctionalityRatings();
        this.getDescription();
      }
    },
    getFunctionalityRatings() {
      const requestSentTime = Date.now();
      
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_get_functionality_ratings',
          bookmaker_functionality: this.secondOrderFunctionalityName ? this.secondOrderFunctionalityName : this.selectedItemName
        })
        .then(response => {
          this.items = response.data.data;
          this.showMessage = this.getNonZeroItemsCount() < this.bookmakersCount && !this.functionalityName;
          this.sortItemsByValue();
          if (this.isSecondOrderModal) {
            this.handleDataLoaded(requestSentTime);
          }
        });
    },
    getBookmakerRatings() {
      const requestSentTime = Date.now();

      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_get_bookmaker_rating',
          bookmaker: this.bookmakerName,
          combineData: true
        })
        .then(response => {
          console.log(response);
          const ratings = response.data.data;
          this.items = Object.values(ratings)
            .filter(rating => rating.value !== false && rating.value !== '0')
            .sort((a, b) => {
              const aValue = typeof a.value === 'boolean' && a.value ? 11 : Number(a.value);
              const bValue = typeof b.value === 'boolean' && b.value ? 11 : Number(b.value);

              if (aValue === bValue) {
                return Number(b.priority) - Number(a.priority);
              } else {
                return bValue - aValue;
              }
            });
          if (this.isBookieAllRatingsModal || this.functionalityName) {
            this.getBonusData();
          }
          if (!this.isSecondOrderModal && !(this.isBookieAllRatingsModal || this.functionalityName)) {
            this.handleDataLoaded(requestSentTime);
          }
        });
    },
    getDescription() {
      const functionalityFieldName = this.selectedItemName.toLowerCase().replace(/ /g, '_');
      const requestSentTime = Date.now();

      axios
        .get(`/wp-json/acf/v3/options/bukmacherzy?_fields=acf.opisy_funkcjonalnosci_bukmacherow.opis_` + functionalityFieldName + `&acf_format=standard`)
        .then(response => {
          this.description = response.data.acf.opisy_funkcjonalnosci_bukmacherow[`opis_` + functionalityFieldName];
          if (!this.isSecondOrderModal) {
            this.handleDataLoaded(requestSentTime);
          }
      });
    },
    getBonusData() {
      const requestSentTime = Date.now();

      axios.get('/wp-json/acf/v3/pages/' + this.rankingBukmacherowPageId + '/sections').then(response => {
        const bookies = response.data.sections[0].bukmacherzy_legalni;
        this.bonusData = bookies.find((bookie) => bookie.name.toLowerCase() === this.bookmakerName.toLowerCase())
        this.handleDataLoaded(requestSentTime);
      });
    },
    getNonZeroItemsCount() {
      return this.items.filter(item => item.value !== '0' && item.value).length;
    },
    sortItemsByValue() {
      this.items.sort((a, b) => {
        if (b.value === a.value) {
          return a.name.localeCompare(b.name);
        }
        return b.value - a.value;
      });
    },
    handleDataLoaded(requestSentTime) {
      const currentTime = Date.now();
      const timeDifference = currentTime - requestSentTime;
      const delay = timeDifference < 1000 ? 1000 - timeDifference : 0;

      setTimeout(() => {
        this.isModalDataLoading = false;
      }, delay);
    },
    openModal(itemName) {
      if (!this.isBookmakerRankingPage) {
        this.isSecondOrderModal = true;
        this.isModalDataLoading = true;
        this.secondOrderFunctionalityName = itemName;
        this.$emit('open-modal', itemName);
        this.getData();
      }
    },
    closeModal() {
      this.$emit('close-modal');
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    handleResize() {
      if (this.isBookieAllRatingsModal && window.size.desktop) {
        this.closeModal();
      }
    }
  }
};
</script>
